export const ActionType = {
  create: "CREATE",
  fetchall: "Fetch_All",
  getId: "GET_ID",
  update: "UPDATE",
  delete: "DELETE",
  like: "LIKE",
  dislike: "DISLIKE",

  //Authentication
  auth: "AUTH",
  logout: "LOGOUT",

  //searchbar
  FETCH_BY_SEARCH: "FETCH_BY_SEARCH",
  END_LOADING: "END_LOADING",
};
